export const IMG = {
  main_logo: "/img/main-enter.jpg",
  sign: require("../../assets/svg/sign.svg").default,
  companies: require("../../assets/svg/jurisdiction.svg").default,
  requests: require("../../assets/svg/request.svg").default,
  deals: require("../../assets/svg/deals.svg").default,
  orders: require("../../assets/svg/orders.svg").default,
  contr: require("../../assets/svg/contragent.svg").default,
  plus_btn: require("../../assets/svg/plus_button.svg").default,
  filter_list: require("../../assets/svg/filter_list.svg").default,
  fav_red: require("../../assets/svg/favorite_red.svg").default,
  fav: require("../../assets/svg/favorite.svg").default,
  home: require("../../assets/svg/home.svg").default,
  profile: require("../../assets/svg/profile.svg").default,
  exchange: require("../../assets/svg/course.svg").default,
  support: require("../../assets/svg/support.svg").default,
  info: require("../../assets/svg/info.svg").default,
  lock_black: require("../../assets/svg/lock_black.svg").default,
  exit: require("../../assets/svg/exit.svg").default,
  lock: require("../../assets/svg/lock.svg").default,
  back: require("../../assets/svg/back.svg").default,
  avatar: require("../../assets/image/avatar.svg").default,
  close_acc: require("../../assets/svg/close_account.svg").default,
  upload: require("../../assets/svg/upload.svg").default,
  message: require("../../assets/svg/message.svg").default,
  download: require("../../assets/svg/download.svg").default,
  ok_btn: require("../../assets/svg/btn_ok.svg").default,
  close: require("../../assets/svg/close.svg").default,
  file_send: require("../../assets/svg/file_send.svg").default,
  download_bank: require("../../assets/svg/download_bank.svg").default,
  money_bag: require("../../assets/svg/money_bag.svg").default,
  legal: "/img/legal.png"
}
